import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import vuetify from "./plugins/vuetify";
import confirmDialog from "./components/confirm-dialog";
import infoDialog from "./components/info-dialog";
import VueQrcodeReader from "vue-qrcode-reader";
import VueTheMask from "vue-the-mask";
import PromptDialog from "./components/prompt-dialog";

Vue.use(VueQrcodeReader);

Vue.config.productionTip = false;

Vue.prototype.$confirm = (message, cb) => {
  confirmDialog.open(message, cb);
};

Vue.prototype.$info = (title, body, type) => {
  infoDialog.open(title, body, type);
};

Vue.prototype.$prompt = PromptDialog;

Vue.use(VueTheMask);

Vue.prototype.$toBrl = (number) => {
  let n = number;
  if (isNaN(n)) n = 0;
  if (typeof number !== "number") {
    n = parseFloat(number);
  }
  return (n / 100).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    style: "currency",
    currency: "BRL",
  });
};

Vue.prototype.$showObservation = () => {
  return localStorage.getItem("showObservation");
};

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
